import {
    Container,
    Row,
    Col,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane
} from 'reactstrap';
import styles from './styles.module.scss';
import clsx from "classnames";
import PropTypes from "prop-types";
import React, { useState } from 'react';
import classnames from 'classnames';
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"

export default function NewBlogDetails2({
    className,
    page,
}) {
    const [activeTab, setActiveTab] = useState('0');

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };
    return (
        <section className={clsx(className, styles.root)}>
            <Container>
                {page?.case_study_left_column?.length >= 1 && (
                    <>
                        <Row className={`pb-5`}>
                            <Col lg={3} className={"left d-flex flex-wrap gap-2 mb-4 mb-lg-0"}>
                                {page?.case_study_left_column.map((post, index) =>
                                    <div key={index} className='w-100'>
                                        <div>{post.title}</div>
                                        <div className='post-highlight'>{post.content}</div>
                                    </div>
                                )}
                            </Col>
                            <Col lg={9} className="position-relative highlights-wrapper">
                                {page?.case_study_right_column_highlights.map((post, index) =>
                                    <div key={index} className='column'>
                                        <div className='inner-column d-flex'>
                                            <SourceFlowImage
                                                src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                                size="300x300"
                                                alt={post?.title}
                                                className="card-img mt-3"
                                                width="100%"
                                                height="100%"
                                            />
                                            <div>
                                                <div className='post-highlight'>{post.title}</div>
                                                <div>{post.content}</div>
                                            </div>
                                        </div>

                                    </div>
                                )}
                            </Col>
                        </Row>
                        <hr />
                    </>
                )}
                <Row className={`${page.case_study_left_column?.length >= 1 && ("pt-5")}`}>
                    <Col lg={3} className={"left mb-4 mb-lg-0"}>
                        <div className='sticky'>
                            <Nav tabs vertical>
                                {page.case_study_tabs.map((post, index) =>
                                    <NavItem key={index}>
                                        <NavLink
                                            className={classnames({ active: activeTab === `${index}` })}
                                            onClick={() => { toggle(`${index}`); }}
                                        >
                                            {post.title}
                                        </NavLink>
                                     </NavItem>
                                )}
                            </Nav>
                        </div>
                    </Col>
                    <Col lg={9} className="position-relative">
                        <TabContent activeTab={activeTab}>
                            {page.case_study_tabs.map((post, index) => (
                                <TabPane tabId={`${index}`} key={index}>
                                    <div className="post-content" dangerouslySetInnerHTML={{ __html: post.content }} />
                                </TabPane>
                            ))}
                        </TabContent>
                    </Col>
                </Row>
            </Container>
        </section >
    )
}



NewBlogDetails2.defaultProps = {
    pathPrefix: "",
    className: "py-5",
};

NewBlogDetails2.propTypes = {
    pathPrefix: PropTypes.string,
    className: PropTypes.string,
};